/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AudioRecorderComponent } from './audio-recorder.component';

@Component({
  imports: [NgSelectModule, CommonModule, ReactiveFormsModule, AudioRecorderComponent, FormlyModule],
  standalone: true,
  selector: 'formly-field-record-audio',
  template: `
    <div class="mb-3">
      <label [attr.for]="id" class="form-label">
        {{ props.label }}
        <span *ngIf="props.required && !props['hideRequiredMarker']" aria-hidden="true">*</span>
      </label>
      <div>
        <oc-audio-recorder
          #audioRecorder
          (audio)="audio($event)"
          (levels)="addLevel($event)"
          [visualise]="!!props['visualise']"
          [autoStart]="props['autoStart']"
        ></oc-audio-recorder>
      </div>
      <div *ngIf="showError" class="invalid-feedback" [style.display]="'block'">
        <formly-validation-message
          id="{{ id }}-formly-validation-error"
          [field]="field"
          role="alert"
        ></formly-validation-message>
      </div>
    </div>
  `,
})
export class FormlyFieldRecordAudio extends FieldType<FieldTypeConfig> implements OnInit {
  public levels: number[] = [];
  private levelCount = 0;

  @ViewChild('audioRecorder') audioRecorder: AudioRecorderComponent;

  ngOnInit(): void {
    this.props['stop']?.subscribe((x: any) => {
      this.audioRecorder.record();
    });
  }

  audio(blob: Blob) {
    const levels = this.levels;
    this.formControl.setValue({ blob, levels });
  }

  addLevel(level: number) {
    if (this.levelCount % 20 === 0) {
      this.levels.push(level);
    }
    this.levelCount += 1;
  }
}
